export default __webpack_public_path__ + "static/media/mac-n-cheese-stir.012fecd3.mp3";